'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'person-walking';
var width = 384;
var height = 512;
var aliases = [128694,"walking"];
var unicode = 'f554';
var svgPathData = 'M192 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-13.6 80c7.4 0 14.6 1 21.6 3l0 154.8-22.2-14.8c-11.1-7.4-17.8-19.9-17.8-33.3l0-107.6c6-1.4 12.2-2.2 18.4-2.2zM91.7 214.2l20.3-20.3 0 75.8c0 29.4 14.7 56.9 39.2 73.2l91.4 60.9c9.6 6.4 15.9 16.6 17.5 28l12.2 91.3c1.8 13.1 13.8 22.4 27 20.6s22.4-13.8 20.6-27l-12.2-91.3c-3.3-25.1-17.3-47.5-38.4-61.6l-21.2-14.1 0-151.3 11.1 12.3c16.7 18.5 40.5 29.1 65.4 29.1l35.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-35.5 0c-11.3 0-22.1-4.8-29.7-13.2l-22.4-24.9c-24-26.6-58.1-41.8-93.9-41.8-33.5 0-65.7 13.3-89.4 37L57.8 180.3C41.3 196.8 32 219.2 32 242.5L32 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-53.5c0-10.6 4.2-20.8 11.7-28.3zm33.8 195.2c-1.9 6.5-5.4 12.5-10.2 17.3L39 503c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l76.3-76.3c10.6-10.6 18.3-23.7 22.4-38l2-7-41.9-28-6.2 21.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPersonWalking = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;